import { Link } from "react-router-dom";
// import dataApplicationsContext from '../context/dataApplicationsContext';
import { useContext } from 'react';

const ErrorMissing = () => {
  // const { openSideBar } = useContext(dataApplicationsContext);
  
  return (
    <div className={`bodyContainer`}>
      <div className="oops-container">
        <div className="oops-wrapper" id="oops-wrapper-404">
          <div className="oops-content">
            <div className="oops-text">
              <div className="oops-title">
                <h1>Oups !</h1>
              </div>
              <p>Désolé, mais Stormie le chat de la DSI a mangé le fil ! <br /> Ou alors, la page que tu recherches n'existe pas...</p>
            </div>
            <Link to="/" className="oops-btn">Retour à l'accueil</Link>
          </div>
          <img src="/images/Error-cat-104-4.svg" alt="Error-404" className="img-error"></img>
        </div>
      </div>
    </div>
  )
}

export default ErrorMissing